<template>
  <ProfileCard
    :title="$t('components.profile.view.language.title')"
    :subtitle="$t('components.profile.view.language.subtitle')"
  >
    <template #dropdown>
      <Flag
        :languageCode="user.locale"
        :title="user.locale"
        class="h-7 w-7 md:mt-1 mr-2"
      />
    </template>
    <ProfileLanguage
      :user="user"
      :busy="busy"
      @updateLanguage="$emit('updateLanguage', $event)"
      class="w-full"
    >
      <Button
        variant="secondary"
        type="grey"
        :size="maxSmall ? 'xl' : 'md'"
        class="mt-2 w-full"
      >
        {{ $t("components.profile.view.language.button") }}
      </Button>
    </ProfileLanguage>
  </ProfileCard>
</template>

<script setup>
import { Button } from "@/SharedComponents/Buttons";
import { Flag } from "@/SharedComponents/Flags";
import { ProfileCard } from "@/SharedComponents/Profile/Partials";
import { ProfileLanguage } from "@/SharedComponents/Profile/Dialogs";
import { useBreakpoints } from "@/Composables/useBreakpoints";

const { maxSmall } = useBreakpoints();

defineEmits(["updateLanguage"]);

defineProps({
  user: { type: Object, required: true },
  busy: { type: Boolean, required: false },
});
</script>
